import { getColor } from '../../../styling/mixins/colors';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import styled from 'styled-components';
import Icon from '../../Icon';
import { fontFamily, text } from '../../../styling/mixins/typography';

export const QuickSearchWrapper = styled.div`
  z-index: 62;
  display: flex;
  flex-grow: 1;
  ${breakpoint('large')} {
    max-width: 584px;
  }

  .quick-search__form {
    width: 100%;
  }

  .quick-search__input-section {
    width: 100%;
    margin: 0;

    ${breakpoint('large')} {
      padding: 0;
    }
  }
  .quick-search__input-wrapper {
    position: relative;
    width: 100%;
  }
`;

interface QuickSearchInputProps {
  $inputActive: boolean;
}

export const QuickSearchInput = styled.input<QuickSearchInputProps>`
  ${text('large')}
  display: flex;
  width: 100%;
  flex-grow: 1;
  padding: 0 1.2rem;
  height: 4rem;
  ${fontFamily}
  line-height: 150%;
  color: ${getColor('gray', 900)};
  background-color: ${getColor('white')};
  border: 1px solid ${getColor('grey', 700)};
  border-color: ${(props) => props.$inputActive ? getColor('grey', 600) : getColor('grey', 700)};
  border-radius: 4px;
  -webkit-appearance: none;
  -webkit-border-radius: 0px;
  border-radius: 5px;
  ${breakpoint('large')} {
    // color: ${getColor('white')};
    // border-radius: 0;
    // background-color: ${getColor('grey', 700)};
  
    // &::placeholder {
    //   color: ${getColor('white')} !important;
    // };
  }
  &:active,
  &:focus {
    background-color: ${getColor('white')};
    color: ${getColor('gray', 900)};
    &::placeholder {
      color: ${getColor('gray', 900)};
    }
  }
  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }
  &::placeholder {
    color: ${getColor('grey', 700)};
  }  
`;

export const QuickSearchIcon = styled(Icon)<QuickSearchInputProps>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1.2rem;
  margin: 0;
  font-size: 2.4rem;
  fill: ${getColor('white')}!important;
  color: ${(props) => (props.$inputActive ? getColor('white') : null)};
  width: 2rem;
  height: 2rem;
`;

export const FooterBarQuickSearchIcon = styled(Icon)<QuickSearchInputProps>`
  margin: 0;
  // font-size: 2.4rem;
  // fill: ${getColor('white')}!important;
  // color: ${(props) => (props.$inputActive ? getColor('white') : null)};
  // scale: 1.5;
`;
